import apiClient from "./apiClient";

export const listNotificationEventConfigurations = () =>
  apiClient.get("/admin/notifications/events");

export const getNotificationEventConfiguration = (eventKey) =>
  apiClient.get(`/admin/notifications/events/${encodeURIComponent(eventKey)}`);

export const updateNotificationEventConfiguration = (eventKey, payload) =>
  apiClient.put(`/admin/notifications/events/${encodeURIComponent(eventKey)}`, payload);

export const previewNotificationTemplate = (eventKey, payload) =>
  apiClient.post(`/admin/notifications/events/${encodeURIComponent(eventKey)}/preview`, payload);

export const restoreNotificationTemplateDefault = (eventKey) =>
  apiClient.post(`/admin/notifications/events/${encodeURIComponent(eventKey)}/restore-default`);

export const listEligibleNotificationUsers = (eventKey) =>
  apiClient.get(`/admin/notifications/events/${encodeURIComponent(eventKey)}/eligible-users`);

export const listNotificationHistory = (params = {}) =>
  apiClient.get("/admin/notifications/history", { params });
